import { render, staticRenderFns } from "./PreviewInteractiveTemplateForm.vue?vue&type=template&id=b1573472&scoped=true"
import script from "./PreviewInteractiveTemplateForm.vue?vue&type=script&lang=js"
export * from "./PreviewInteractiveTemplateForm.vue?vue&type=script&lang=js"
import style0 from "./PreviewInteractiveTemplateForm.vue?vue&type=style&index=0&id=b1573472&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1573472",
  null
  
)

export default component.exports